import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/check.svg'
import _imports_1 from '@/assets/icons/x.svg'
import _imports_2 from '@/assets/icons/hand.svg'


const _withScopeId = n => (_pushScopeId("data-v-07e01ad5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen screen-overlay" }
const _hoisted_2 = { class: "scenario-container" }
const _hoisted_3 = { class: "scenario-actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "Discuss scenario"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Discuss ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_1,
  alt: "Skip scenario"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Skip ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2,
  alt: "Raise hand"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Raise Hand ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Undo")
const _hoisted_13 = {
  key: 0,
  class: "scenario-skips"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_scenario_text = _resolveComponent("scenario-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_scenario_text, { scenario: _ctx.scenario }, null, 8, ["scenario"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.mode === 'select')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "btn btn-green",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args)))
              }, _hoisted_6),
              (_ctx.player.remainingSkips)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-red",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.skip && _ctx.skip(...args)))
                  }, _hoisted_9))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.mode === 'discuss' && _ctx.state !== 'answered')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-yellow",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleHand && _ctx.toggleHand(...args)))
            }, [
              (_ctx.state === 'idle')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_10,
                    _hoisted_11
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_12
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.mode === 'select')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_ctx.player.remainingSkips)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.player.remainingSkips) + " " + _toDisplayString(_ctx.player.remainingSkips === 1 ? 'skip' : 'skips') + " remaining ", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_15, "Sorry - you are all out of skips!"))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}